var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import useLocalization from '../../../../hooks/useLocalization';
import { EditorToolbarCheckBox } from './EditorToolbarCheckBox';
import styled from 'styled-components';
export var CheckBoxCardContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: #1f1f1f;\n  padding: 0;\n  color: #909090;\n  column-gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  background: #1f1f1f;\n  padding: 0;\n  color: #909090;\n  column-gap: 8px;\n"])));
export var BookCheckBox = function (props) {
    var value = props.value, onChange = props.onChange, isModal = props.isModal;
    var t = useLocalization().t;
    if (isModal)
        return (React.createElement(EditorToolbarCheckBox, { value: value, onChange: onChange, isModal: isModal, label: t('edit_buttons.sell_with_book') }));
    return (React.createElement(CheckBoxCardContainer, null,
        React.createElement(EditorToolbarCheckBox, { value: value, onChange: onChange, isModal: isModal, label: t('edit_buttons.sell_with_book') })));
};
var templateObject_1;
//# sourceMappingURL=BookCheckBox.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import useLocalization from '../../../../hooks/useLocalization';
import { EditorToolbarCheckBox } from './EditorToolbarCheckBox';
import styled from 'styled-components';
export var CheckBoxCardContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: #1f1f1f;\n  padding: 0;\n  color: #909090;\n  column-gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  background: #1f1f1f;\n  padding: 0;\n  color: #909090;\n  column-gap: 8px;\n"])));
export var BookCheckBox = function (props) {
    var value = props.value, onChange = props.onChange, isModal = props.isModal;
    var t = useLocalization().t;
    if (isModal)
        return (React.createElement(EditorToolbarCheckBox, { value: value, onChange: onChange, isModal: isModal, label: t('edit_buttons.sell_with_book') }));
    return (React.createElement(CheckBoxCardContainer, null,
        React.createElement(EditorToolbarCheckBox, { value: value, onChange: onChange, isModal: isModal, label: t('edit_buttons.sell_with_book') })));
};
var templateObject_1;
//# sourceMappingURL=BookCheckBox.js.map